<template>
  <span class="tips-wrapper">
    <img v-if="type==='deliveryInfo'" class="deliveryTip" @click="changeTip" :src="require('@assets/images/deliveryTip.png')" />
    <div class="tips" v-if="showTipFlag">{{ desc }}</div>
  </span>
</template>

<script>
import { Tooltip } from "element-ui";
export default {
  name: 'DeliveryTip',
  components: {
    Tooltip
  },
  props: {
    showTipFlag: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'deliveryInfo'
    },
    desc: {
      type: String,
      default: window.TLang('distributionTime', 'orderConfirm'),
    },
  },
  methods: {
    changeTip(){
      this.showTipFlag = !this.showTipFlag
      // console.log(this.showTipFlag);
    },
  },
};
</script>

<style lang="less">
.tips-wrapper {
  position: relative;
  img.deliveryTip{
    width:14px;
    height:14px;
    cursor: pointer;
  }
  .tips {
    position: absolute;
    top: 26px;
    left: -52px;
    width: 297px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 16px;
    padding:8px 12px;
    background: rgba(0,0,0,0.7);
    z-index: 9;
    white-space: pre-wrap;
    box-shadow: 0px 2px 8px 0px rgba(53, 59, 64, 0.15);
    border-radius: 2px;
    box-sizing:border-box;
    &::after {
      content: '';
      display: inline-block;
      position: absolute;
      top: -14px;
      left: 52px;
      border: 7px solid;
      border-color: transparent transparent  rgba(0,0,0,0.7);
    }
  }
}
</style>
